export {
  // for bridge
  type Query,
  type Mutation,
  type ClientExtension,
  type ClientExtensionMutationsActivateArgs,
  type ClientExtensionMutationsDeactivateArgs,
  type ApplicationQueriesFindAllArgs,
  type ApplicationQueriesFindAllForPatientArgs,
  type FindAllApplicationsInput,
  type FindAllApplicationsForPatientInput,
  type Application,
  type ApplicationForPatient,
  type AppToken,
  type AppTokenMutationsGenerateAppTokenArgs,
  type GenerateAppTokenInput,
  // for bridge-react
  type Manifest,
  Iso as ISO,
  // for extensions generator
  Status,
  Category,
  // for entitlements
  FronteggExtensionsFeatureKeys,
} from './__generated__/graphql';
